export default {
    domain: process.env.PREACT_APP_API_URL
}